module.exports = __webpack_public_path__ + "static/media/larry_page.f0027339.jpg";